import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const ContactUs = () => {
    const backendUrl = "https://profitree-backend-9482feeffc4a.herokuapp.com";
    const [formData, setFormData] = useState({
        email: '',
        message: ''
    });
    const [formStatus, setFormStatus] = useState('');
    const [toast, setToast] = useState({ show: false, type: '', message: '' });
    const navigate = useNavigate();

    // Autofill email from localStorage
    useEffect(() => {
        const storedEmail = localStorage.getItem('username') || '';
        setFormData((prev) => ({ ...prev, email: storedEmail }));
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setFormStatus('Submitting...');
        setToast({ show: false, type: '', message: '' });
        try {
            const response = await axios.post(`${backendUrl}/contact`, null, {
                params: {
                    name: 'ProfiTree User', // Default name
                    email: formData.email,
                    message: formData.message
                },
            });
            if (response.status === 200 && response.data === 'Thank you! Your message has been received.') {
                setFormStatus('Thank you! Your message has been sent.');
                setFormData({ ...formData, message: '' });
                setToast({ show: true, type: 'success', message: 'Your message has been sent! Redirecting to dashboard...' });
                setTimeout(() => {
                    navigate('/tax-insights');
                }, 1800);
            } else {
                setFormStatus('Something went wrong. Please try again later.');
                setToast({ show: true, type: 'error', message: 'Something went wrong. Please try again later.' });
            }
        } catch (error) {
            setFormStatus('Error submitting the form. Please check your internet connection and try again.');
            setToast({ show: true, type: 'error', message: 'Error submitting the form. Please check your internet connection and try again.' });
        }
    };

    const styles = {
        container: {
            padding: '32px',
            width: '100%',
            maxWidth: '370px',
            margin: '60px auto',
            borderRadius: '16px',
            backgroundColor: '#fff',
            boxShadow: '0 8px 32px rgba(38,70,83,0.10)',
            textAlign: 'center',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            minHeight: '380px',
            border: '1.5px solid #e0e4e7',
        },
        title: {
            fontSize: '26px',
            color: '#264653',
            marginBottom: '18px',
            fontWeight: 700,
            letterSpacing: 0.2,
        },
        subtitle: {
            fontSize: '15px',
            color: '#2a9d8f',
            marginBottom: '22px',
            fontWeight: 500,
        },
        formGroup: {
            textAlign: 'left',
            marginBottom: '18px',
        },
        label: {
            display: 'block',
            fontSize: '14px',
            color: '#264653',
            marginBottom: '7px',
            fontWeight: 600,
        },
        input: {
            width: '100%',
            padding: '12px',
            fontSize: '15px',
            borderRadius: '8px',
            border: '2px solid #e0e0e0',
            marginBottom: '8px',
            background: '#f8f9fa',
            color: '#264653',
            fontWeight: 500,
            transition: 'border 0.2s',
        },
        inputDisabled: {
            background: '#eafaf7',
            color: '#2a9d8f',
            fontWeight: 600,
            border: '2px solid #2a9d8f',
        },
        textarea: {
            width: '100%',
            padding: '12px',
            fontSize: '15px',
            borderRadius: '8px',
            border: '2px solid #e0e0e0',
            minHeight: '90px',
            background: '#f8f9fa',
            color: '#264653',
            fontWeight: 500,
            resize: 'vertical',
        },
        button: {
            width: '100%',
            padding: '14px',
            fontSize: '16px',
            backgroundColor: '#2a9d8f',
            color: '#fff',
            border: 'none',
            borderRadius: '8px',
            cursor: 'pointer',
            fontWeight: 700,
            marginTop: '8px',
            boxShadow: '0 4px 16px rgba(42,157,143,0.10)',
            letterSpacing: 0.2,
            transition: 'background 0.2s',
        },
        buttonHover: {
            backgroundColor: '#21867a',
        },
        formStatus: {
            marginTop: '18px',
            fontSize: '15px',
            textAlign: 'center',
            color: '#2a9d8f',
            fontWeight: 600,
        },
        toast: {
            position: 'fixed',
            top: 24,
            left: '50%',
            transform: 'translateX(-50%)',
            zIndex: 9999,
            minWidth: 260,
            maxWidth: 340,
            padding: '16px 24px',
            borderRadius: 10,
            background: '#eafaf7',
            color: '#264653',
            fontWeight: 600,
            boxShadow: '0 4px 24px rgba(42,157,143,0.13)',
            display: 'flex',
            alignItems: 'center',
            gap: 12,
            border: '2px solid',
            borderColor: toast.type === 'success' ? '#2a9d8f' : '#b14552',
        },
        toastIcon: {
            fontSize: 22,
            color: toast.type === 'success' ? '#2a9d8f' : '#b14552',
        }
    };

    return (
        <div style={styles.container}>
            {toast.show && (
                <div style={styles.toast}>
                    <span style={styles.toastIcon}>{toast.type === 'success' ? '✔️' : '❌'}</span>
                    <span>{toast.message}</span>
                </div>
            )}
            <h2 style={styles.title}>Contact ProfiTree Support</h2>
            <div style={styles.subtitle}>We're here to help! Please describe your issue or question below.</div>
            <form onSubmit={handleSubmit} autoComplete="off">
                <div style={styles.formGroup}>
                    <label htmlFor="email" style={styles.label}>Email</label>
                    <input
                        type="email"
                        id="email"
                        name="email"
                        value={formData.email}
                        disabled
                        style={{ ...styles.input, ...styles.inputDisabled }}
                    />
                </div>
                <div style={styles.formGroup}>
                    <label htmlFor="message" style={styles.label}>Message</label>
                    <textarea
                        id="message"
                        name="message"
                        value={formData.message}
                        onChange={handleChange}
                        required
                        style={styles.textarea}
                        placeholder="How can we help you?"
                    ></textarea>
                </div>
                <button type="submit" style={styles.button}>Send Message</button>
            </form>
            {formStatus && <p style={styles.formStatus}>{formStatus}</p>}
        </div>
    );
};

export default ContactUs;